export const GREAT_DEAL_ITEMS = [
  {
    title: 'Avoid the Medicare Levy Surcharge',
    icon: '/icons/health-insurance/levy-surcharge.svg',
    iconDimensions: {
      width: 64,
      height: 64
    }
  },
  {
    title: 'Avoid long waits for surgery',
    icon: '/icons/health-insurance/surgery-waits.svg',
    iconDimensions: {
      width: 64,
      height: 64
    }
  },
  {
    title: 'Find cover that is <br class="hidden md:block"/> right for you',
    icon: '/icons/health-insurance/cover-tailored.svg',
    iconDimensions: {
      width: 64,
      height: 64
    }
  },
  {
    title: 'Save on extras that matter to you',
    icon: '/icons/health-insurance/cut-oop-expenses.svg',
    iconDimensions: {
      width: 64,
      height: 64
    }
  }
]

export const SAVING_PLAN_ITEMS = [
  {
    title: 'It’s easy to switch health cover',
    description: 'Australia has over 3,500 different health insurance policies. So what’s right for you? We make comparing cover so easy, quickly showing you the best value policies from our panel of trusted insurers*',
    sectionImage: `${APP_ASSET_BASEURL}edge/static/images/products/health/saving-plans/switch-cover.svg`,
    sectionImageDimensions: {
      width: 224,
      height: 180
    }
  },
  {
    title: 'No new waiting periods',
    description: 'Switch to equivalent or lower cover and you shouldn’t have to serve any new waiting periods. Our experts can help you make the switch. Upgrading or buying health insurance for the first time? We’ll let you know which funds on our panel are offering to waive waiting periods.',
    sectionImage: `${APP_ASSET_BASEURL}edge/static/images/products/health/saving-plans/waiting-periods.svg`,
    sectionImageDimensions: {
      width: 200,
      height: 180
    }
  },
  {
    title: '10+ years of helping Aussies.',
    description: 'We’ve been saving Aussies hundreds on their health insurance since 2010. Our experts know their cataracts from their chiropractors so you can be confident you’re getting health cover that fits your needs at a price that won’t give you a migraine.',
    sectionImage: `${APP_ASSET_BASEURL}edge/static/images/products/health/saving-plans/10-year-help.svg`,
    sectionImageDimensions: {
      width: 198,
      height: 180
    }
  },
  {
    title: 'Free and simple',
    description: 'We’re free to use, there’s no hidden fees, and our experts take care of all the paperwork. There’s no obligation to buy but we’re confident we can find you a better value policy in a matter of minutes.',
    sectionImage: `${APP_ASSET_BASEURL}edge/static/images/products/health/saving-plans/free.svg`,
    sectionImageDimensions: {
      width: 251,
      height: 180
    }
  },
  {
    title: '30 days cooling off period',
    description: 'Changed your mind? Found a better deal? No worries. You can cancel your new policy anytime during the first 30 days - although we\'re confident you\'ll love how much we can save you.',
    sectionImage: `${APP_ASSET_BASEURL}edge/static/images/products/health/saving-plans/30-day-colling-off.svg`,
    sectionImageDimensions: {
      width: 243,
      height: 180
    }
  }
]

export const GUIDES_ITEMS = [
  {
    title: 'Health insurance for families',
    content: 'Got kids or thinking about having a baby? Here\'s everything you need to know about covering your family.',
    imageUrl: `${APP_ASSET_BASEURL}edge/static/images/products/health/guides/health-insurance-family.png`,
    imageDimensions: {
      width: 291,
      height: 202.8
    },
    pageUrl: '/health-insurance/families/'
  },
  {
    title: 'Health insurance for seniors',
    content: 'Older Australians often have high premiums. Here\'s how seniors can get a good deal on their health cover.',
    imageUrl: `${APP_ASSET_BASEURL}edge/static/images/products/health/guides/health-insurance-seniors.png`,
    imageDimensions: {
      width: 291,
      height: 202.8
    },
    pageUrl: '/health-insurance/seniors/'
  },
  {
    title: 'Health insurance for singles',
    content: 'Just looking for health cover for one? Here\'s how both first-timers and loyal customers can get value for money.',
    imageUrl: `${APP_ASSET_BASEURL}edge/static/images/products/health/guides/health-insurance-single.png`,
    imageDimensions: {
      width: 291,
      height: 202.8
    },
    pageUrl: '/health-insurance/singles/'
  }
]

export const PARTNER_ITEMS = [
  {
    company: 'AHM.svg',
    dimensions: {
      width: 78,
      height: 48
    }
  },
  {
    company: 'Australia-Unity.svg',
    dimensions: {
      width: 143,
      height: 40
    }
  },
  {
    company: 'BUPA.svg',
    dimensions: {
      width: 56,
      height: 56
    }
  },
  {
    company: 'HCF.svg',
    dimensions: {
      width: 141,
      height: 41
    }
  },
  {
    company: 'NIB-update.svg',
    dimensions: {
      width: 128,
      height: 42.66
    }
  },
  {
    company: 'Latrobe.svg',
    dimensions: {
      width: 190.25,
      height: 34.94
    }
  },
  {
    company: 'Peoplecare.svg',
    dimensions: {
      width: 190.25,
      height: 34.94
    }
  }
]

export const PARTNER_ITEMS_MINIMAL = [
  {
    company: 'BUPA.svg',
    dimensions: {
      width: 51,
      height: 51
    }
  },
  {
    company: 'NIB-update.svg',
    dimensions: {
      width: 80.94,
      height: 27.17
    }
  },
  {
    company: 'AHM.svg',
    dimensions: {
      width: 63,
      height: 38.95
    }
  },
  {
    company: 'HCF.svg',
    dimensions: {
      width: 84,
      height: 34.36
    }
  },
  {
    company: 'Latrobe.svg',
    dimensions: {
      width: 102,
      height: 27.2
    }
  }
]

export const FAQ_ITEMS = [
  {
    title: 'How do I choose a private health insurance policy?',
    content: 'The best way to choose a private health insurance policy is to conduct a comprehensive analysis. By looking at what various health funds are offering, you can get a clear idea of what is on the market and find a policy that suits your needs. <p>For a <a class="underline" href="/health-insurance/quote/quick">quick and easy comparison</a>, speak to a health insurance adviser over the phone to receive free quotes tailored to your preferences and budget. It may also be helpful to speak with family and friends who have been customers of various health funds in the past.</p><br><p>But before you get started, you should have a clear idea of what kind of policy you are looking for. Factors to consider include:</p><ul class="list-disc pl-8 my-8"><li><p>Decide if you want <a class="underline" href="/health-insurance/hospital-cover/">Hospital cover</a>, Extras cover or <a class="underline" href="/health-insurance/ambulance-cover/">Ambulance cover</a>, or a combination of these cover types</p></li><li>How much you can afford and are willing to pay each month for your health insurance</li><li>What sort of health care treatments and services you want cover for</li><li><p>Who you want to cover. Are you interested in a <a class="underline" href="/health-insurance/singles/">single</a>, <a class="underline" href="/health-insurance/families/">family</a> or <a class="underline" href="/health-insurance/couples/">couples</a> policy</p></li><li>What level of cover do you think you\'ll require (e.g. do you just want the basics covered, or are you after a comprehensive gold-tiered health insurance policy?)</li><li>Any health concerns you want a policy to specifically cater to</li><li>What is important to you in a health fund (e.g. is it reputation? Customer service? Percentage of claims paid out?)</li></ul><p>From here, you can do the relevant research that allows you to ultimately choose the best private health insurance for you.</p>'
  },
  {
    title: 'Who has the best health insurance policy?',
    content: 'Each health fund will have various benefits and policy features that some individuals may prefer over others. It is difficult to define "the best health insurance policy" when each Australian has different needs and preferences when it comes to protecting themselves and their families from unexpected health care expenses. <p>Generally, the best health insurance policy for you will be the one that:</p><ul class="list-disc pl-8 my-8"><li><p>Is comfortable within your <strong>budget</strong></p></li><li><p>Provides the <strong>type</strong> of cover you want</p></li><li><p>Provides the <strong>level</strong> of cover you want</p></li><li><p>Is set up with a <strong>company</strong> you trust</p></li><li><p>Is <strong>transparent</strong> about its conditions</p></li><li><p>Is <strong>customisable</strong> to your needs</p></li></ul><p>Once you know what you are looking for, undertaking a private health insurance comparison can help you identify how each fund competes in premiums, coverage conditions and other factors that are important to you.</p><br><p>Compare Club can help you compare health insurance policies from eight different health funds, including some of <a class="underline" href="/health-insurance/companies/" target="_blank">Australia\'s leading health insurers</a> like Bupa, AHM and HCF.</p>'
  },
  {
    title: 'What is the best private health fund in Australia?',
    content: '<p>It may be useful to investigate the Australian Medical Association\'s annual Health Insurance <a class="underline" href="https://ama.com.au/articles/ama-private-health-insurance-report-card-2020" target="_blank" rel="nofollow noopener noreferrer">Report Card</a>. It aims to shed light on how health insurance really works and provide consumers with clear, concise information regarding different health funds.</p><br><p>Keep in mind, however, that the results of each fund can change drastically year upon year. Before committing to a policy, you should always look at a wide range of factors, conduct a review with the help of our team of industry experts and read the policy documentation from the health fund you are interested in.</p>'
  },
  {
    title: 'What is the difference between Medicare and private health insurance?',
    content: '<p>The main difference is that Medicare only covers hospital treatment as a public patient in a public hospital and a set range of non-hospital services such as GP visits and eye check-ups.</p><br><p>Private health insurance offers <a class="underline" href="/health-insurance/benefits/">benefits</a> beyond the public health system. Ambulance journeys and some out-of-hospital costs such as dental check-ups and glasses are not covered by Medicare.</p><br><p>In addition, appropriate private health cover allows you to choose your own doctor, be treated as a private patient in a public hospital (with access to improved facilities like a private room, subject to availability), cover gap fees and bypass long public hospital elective surgery waiting lists by choosing to have your treatment in a private hospital.</p><br><p>There are multiple government incentives for people to buy private health insurance, such as avoiding the <a class="underline" href="/health-insurance/medicare-levy-surcharge/">Medicare Levy surcharge</a>.</p>'
  },
  {
    title: 'How much does private health insurance cost in Australia?',
    content: '<p>How much you pay for private health insurance depends on what level of cover you want and which provider you choose. On average, health insurance policies cost between $2000 to $3000 per year depending on whether you have hospital cover, extras cover, or a mixture of hospital and extras cover (combined policy).</p>'
  },
  {
    title: 'How much does switching private health insurance cost?',
    content: '<p>It doesn’t cost anything to compare health insurance and switch to a better policy, so there’s no downside to choosing something better. For example, if you feel you’re paying too much in private health insurance premiums, you can shop around for a cheaper policy that still covers the things that are important to you.</p><br><p>Compare Club makes it easy to compare health insurance and choose a better policy. Our specialists will help you compare policies from our panel of trusted private health insurers so you can make the right switch.</p>'
  },
  {
    title: 'Can you switch health insurance at any time?',
    content: '<p>Just because you are already signed up with a health insurance provider does not mean you are locked in forever. If you find a better alternative, you will not be penalised for shopping around.</p><br><p>You can do your own health insurance comparison and switch at any time without incurring additional charges.</p><br><p>Even better, if you have already paid some health insurance premiums in advance and you decide to switch, your insurer will calculate the difference and refund the remaining balance, usually in full.</p><br><p>Just remember that your unserved waiting periods will transfer to your new provider. So if you end up switching health insurance to an equivalent cover, you may need to finish these waiting periods before making a claim.</p><br><p>Think you could get a better deal? Switching health insurance does not need to be a hassle. <a class="underline" href="/health-insurance/quote/form/step1/">Let us help you</a> through the process of changing providers.</p>'
  },
  {
    title: 'How do you compare private health insurance policies?',
    content: '<p>Identify which funds have the features you want, and shop around for value. It sounds simple, but health insurance can be confusing. Start by reading our guide on <a class="underline" href="/health-insurance/switch/">how to compare</a> and select the right policy.</p><br><p>It is worth taking time to note down what health services you and your partner or family need today and in the future.</p><br><p>Doing this will make it easier to decide what level of hospital cover you need; <a class="underline" href="/health-insurance/gold/">Gold</a>, <a class="underline" href="/health-insurance/2019-health-reforms-silver/">Silver</a>, <a class="underline" href="/health-insurance/2019-health-reforms-bronze/">Bronze</a> or <a class="underline" href="/health-insurance/2019-health-reforms-basic/">Basic</a>. Look for the health fund package that includes everything you need without including many items you will likely never use.</p><br><p>Then go through the same exercise for your <a class="underline" href="/health-insurance/extras-cover/">extras</a>. Do you wear glasses? How much are you currently paying for a <a class="underline" href="/health-insurance/dental/">dental</a> check-up? Are you likely to need physio in the future?</p><br><p>There are other things to consider when choosing a health fund. <a class="underline" href="/health-insurance/no-waiting-periods/">How long will you have to wait</a> before you can access treatment? What rebates can I get? Are there any limits to what I can claim on my extras? Will I get hit by <a class="underline" href="/health-insurance/the-gap/">gap fees</a>?</p><br><p>As you can tell, trying to compare health insurance can be a time consuming and confusing process. That is why our specialists can compare policies from our panel of insurers in a matter of minutes and <a class="underline" href="/health-insurance/quote/form/step1/">quickly help you find the cover you need</a> at a price you can afford. If you’re looking for a quick and easy health insurance comparison, Compare Club has you covered.</p>'
  },
  {
    title: 'How does switching private health insurance work?',
    content: '<p>Switching to another private health insurer is easier than you might think. All you need to do is contact the private health fund that offers the new policy you want to switch to. When you decide to make the switch, your former health fund will generate a clearance certificate for your new health fund.</p><br><p>Alternatively, you could leave all the hard work to the experts at Compare Club. Just provide us with some basic information about your personal circumstances (single, couple, family etc.) and what type of cover you’re looking for, and we’ll take care of the rest. Our specialists will provide you with the best possible policy options from a range of private health funds, leaving the final decision to you.</p><br><p>Learn more about <a class="underline" href="/health-insurance/switch/">how to switch your health insurance</a>.</p>'
  },
  {
    title: 'How do you determine what to compare between health plans?',
    content: '<p>It can be hard to compare health insurance in Australia due to how many competitive options there are. Many policies, on the surface, are very similar, and unless you’re pretty familiar with the industry, figuring out the best policy for you can be difficult.</p><br><p>Think about what’s most important for you with a new health insurance policy and see how different private health funds stack up in those areas. If it all gets a bit much, don’t worry, you can use Compare Club to get a quick comparison from our health insurance experts. We’ll help you find private health insurance that covers what you need at a price you can afford.</p>'
  },
  {
    title: 'How much tax do you save with private health insurance?',
    content: '<p>Having appropriate private health insurance from an early age means you can avoid the <a class="underline" href="/health-insurance/medicare-levy-surcharge">Medicare Levy Surcharge (MLS)</a>, avoid <a class="underline" href="/health-insurance/lifetime-health-cover-loading">Lifetime Health Cover loading</a> and likely get the Australian government health insurance rebate.</p><br><p>If you earn over $93,000 as an individual or $186,000 as a family, you need to take out private health insurance to avoid being hit by the Medicare Levy Surcharge. This can be up to 1.5% of your income, depending on how much you earn.</p><br><p>Lifetime health cover loading, meanwhile, affects people who do not take out private hospital insurance before they are 31. If you decide to take our cover at a later age, you will pay a loading fee.</p><br><p>This is 2% for each year you did not hold cover from the 1st of July following your 31st birthday. So, if you are 35 when you decide to take out private health cover, you will pay a 10% loading fee. LHC is capped at 70%.</p>'
  },
  {
    title: 'What is the private health insurance rebate?',
    content: '<p>The private health insurance rebate is money the government contributes towards paying your private health insurance premiums. Your age and income determine the exact rebate you get.</p><br><p>You can claim the rebate through your health fund or apply it when you lodge your yearly tax return. Learn more about <a class="underline" href="/health-insurance/rebate/">how the private health insurance rebate works in Australia</a>.</p>'
  },
  {
    title: 'What if I have pre-existing conditions?',
    content: '<p>If you have pre-existing conditions, you may not get immediate cover for what you want and will have to serve a waiting period before you can claim. If you are switching your health insurance policy to one with an equal or lesser level of cover, you will not need to re-serve waiting periods.</p><br><p>Learn more about <a class="underline" href="/health-insurance/pre-existing-conditions/">pre-existing conditions and health insurance</a>.</p>'
  }
]

export const GLOSSSARY_LIST = [
  {
    title: 'A-F',
    content: `
      <p>
        <strong>Ambulance Cover</strong>: Ambulance cover refers to the insurance coverage for emergency ambulance services. In Australia, ambulance services are generally not covered by Medicare (the public healthcare system) and can result in significant out-of-pocket expenses. Having ambulance cover through private health insurance helps protect individuals from the high costs associated with emergency ambulance transport.
      </p>

      <p>
        It's important to note that ambulance cover requirements and regulations vary between Australian states and territories. Some states provide free or subsidized ambulance services to their residents, while others require individuals to have their own ambulance cover. It's crucial to check the specific requirements and regulations in your state or territory and ensure that you have adequate ambulance cover in place to avoid potential financial burden during emergency situations.
      </p>

      <p>
        <a href="https://compareclub.com.au/health-insurance/extras-cover/" class="font-bold underline inline-block" target="_blank">Extras Cover</a>: Additional health insurance coverage that provides benefits for services not typically covered by Medicare, such as dental care, optical services, physiotherapy, and chiropractic treatments. Here are some examples of extras that are commonly covered under private health insurance policies in Australia:

        <ul class="list-disc pl-8 my-8">
          <li>
            Dental Extras: Coverage for routine dental treatments, such as check-ups, teeth cleanings, fillings, extractions, and major dental procedures like crowns, bridges, and dentures.
          </li>

          <li>
            Optical Extras: Coverage for optical services and products, including prescription glasses, contact lenses, and prescription sunglasses.
          </li>

          <li>
            Physiotherapy: Coverage for physiotherapy sessions, which involve rehabilitative exercises, manual therapy, and other treatments for musculoskeletal conditions and injuries.
          </li>

          <li>
            <a href="https://compareclub.com.au/health-insurance/guide-to-private-health-insurance-for-chiropractic-care/" class="font-bold underline inline-block" target="_blank">Chiropractic Services</a>: Coverage for chiropractic treatments, which focus on diagnosing and treating musculoskeletal disorders, particularly related to the spine.
          </li>

          <li>
            Remedial Massage: Coverage for therapeutic massage treatments aimed at relieving muscle tension, improving circulation, and reducing pain and discomfort.
          </li>

          <li>
            Occupational Therapy: Coverage for occupational therapy services, which help individuals improve their ability to perform daily activities and tasks related to work, rehabilitation, or disability management.
          </li>

          <li>
            Psychology/Counselling: Coverage for psychology or counselling sessions to address mental health concerns, such as anxiety, depression, and stress management.
          </li>

          <li>
            Naturopathy/Homeopathy: Coverage for consultations and treatments provided by naturopaths or homeopaths, who use natural remedies and therapies to support overall health and well-being.
          </li>

          <li>
            <a href="https://compareclub.com.au/health-insurance/health-insurance-for-podiatric-surgery/" class="font-bold underline inline-block" target="_blank">Podiatry</a>: Coverage for podiatry services, including assessments, treatments, and care for foot-related conditions, such as foot pain, injuries, and diabetic foot care.
          </li>

          <li>
            Hearing Aids: Coverage for hearing aids and related services, including assessments, fittings, and ongoing support for individuals with hearing impairments.
          </li>
        </ul>
      </p>
    `
  },
  {
    title: 'G-L',
    content: `
      <p>
        <a href="https://compareclub.com.au/health-insurance/the-gap/" target="_blank" class="font-bold underline">Gap Cover</a>: An arrangement where private health insurers may provide additional benefits to cover or reduce the out-of-pocket expenses (known as the "gap") incurred by policyholders for in-hospital medical services not fully covered by Medicare.  
      </p>

      <p>
        <strong>General Dental</strong>: General Dental refers to routine dental treatments and preventive care aimed at maintaining oral health. These can include services such as check-ups, teeth cleanings, X-rays, fillings, and basic extractions. General Dental coverage is a common component of extras cover provided by private health insurance policies in Australia. It helps individuals offset the costs of routine dental visits and basic treatments. The level of coverage for General Dental can vary depending on the insurance policy and the specific extras cover chosen by the individual.  
      </p>

      <p>
        <strong>Hospital Cover Tiers</strong>: Hospital cover in Australia is categorized into tiers, which represent different levels of coverage and benefits. These tiers were introduced to simplify and standardize private health insurance policies. The tiers are as follows:
      </p>

      <ol class="mb-4">
        <li class="mb-4">
          a) Gold: Gold is the highest level of hospital cover and provides the widest range of coverage for hospital treatments. It typically includes coverage for all clinical categories and treatments in both public and private hospitals.
        </li>

        <li class="mb-4">
          b) Silver: Silver tier hospital cover offers a comprehensive level of coverage, including a wide range of treatments across different clinical categories. However, it may have some exclusions or restrictions compared to Gold tier cover.
        </li>

        <li class="mb-4">
          c) Bronze: Bronze tier hospital cover provides a medium level of coverage for common treatments and clinical categories. It generally excludes or has limited coverage for higher-cost or specialized treatments.
        </li>

        <li>
          d) Basic: Basic tier hospital cover offers a limited level of coverage and typically covers a narrower range of treatments. It is designed to provide essential coverage for key clinical categories, but may have exclusions or restrictions for certain treatments.
        </li>
      </ol>

      <p>
        <strong>Hospital Cover</strong>: Hospital cover refers to the component of private health insurance that provides coverage for hospital treatments and services. Hospital cover allows individuals to have greater control over their healthcare options by providing access to private hospitals, choice of doctor, shorter waiting times, and accommodation in a private room (depending on the level of cover). Hospital cover typically includes benefits for in-hospital medical procedures, surgeries, accommodation, and related services, such as anesthesia and operating theatre fees.
      </p>

      <p>
        <a href="https://compareclub.com.au/health-insurance/lifetime-health-cover-loading/" class="underline font-bold" target="_blank">Lifetime Health Cover (LHC)</a>: A loading or penalty applied to the premium of private health insurance policies if an individual takes out cover after the age of 30. It incentivizes individuals to maintain continuous private health insurance coverage.
      </p>
    `
  },
  {
    title: 'M-W',
    content: `
      <p>
        <strong>Major Dental</strong>: Major Dental refers to a category of dental treatments that typically involve more extensive procedures and higher costs. These can include treatments such as crowns, bridges, dentures, orthodontics (braces), and oral surgery. Major Dental coverage is a type of extras cover offered by private health insurance policies in Australia. It provides benefits or a percentage of the cost for major dental treatments, helping individuals manage the financial burden associated with these procedures. The specific coverage and limits for Major Dental can vary depending on the insurance policy and level of extras cover chosen by the individual.  
      </p>

      <p>
        <a href="https://compareclub.com.au/health-insurance/medicare-levy-surcharge/" target="_blank" class="font-bold underline">Medicare Levy Surcharge (MLS)</a>: An additional tax imposed on high-income earners who do not have private health insurance and earn above a certain threshold. It encourages individuals to take out private health insurance and reduce the burden on the public healthcare system.
      </p>

      <p>
        <strong>Medicare</strong>: Australia's publicly funded healthcare system that provides basic medical services and subsidized treatments to Australian residents.  
      </p>

      <p>
        <strong>Network</strong>: A group of doctors, hospitals, and other healthcare providers that have contracted with an insurance company to provide services  
      </p>

      <p>
        <strong>No-Gap</strong>: No-Gap refers to a situation where a policyholder does not have to pay any out-of-pocket expenses or the "gap" for certain medical services or treatments. It typically applies to in-hospital services where the medical practitioner agrees to charge an agreed fee and Medicare and health insurance covers the full  No-Gap arrangements can help individuals minimise their expenses for specific procedures or treatments.
      </p>

      <p>
        <a href="https://compareclub.com.au/health-insurance/orthodontics/" target="_blank" class="underline font-bold">Orthodontics</a>: Orthodontics is a branch of dentistry that focuses on correcting misaligned teeth and jaw irregularities. It involves the use of braces, retainers, aligners, and other dental appliances to straighten teeth and improve bite alignment. Orthodontic treatment is typically considered a major dental procedure. Private health insurance policies in Australia may offer coverage for orthodontic treatment under extras cover, specifically under the Major Dental category. It's important to review the specific policy details and waiting periods associated with orthodontic coverage, as there may be limitations and conditions for reimbursement.  
      </p>

      <p>
        <a href="https://compareclub.com.au/health-insurance/student-visitors-australia/" target="_blank" class="font-bold underline">OSHC (Overseas Student Health Cover)</a>: OSHC is a specific type of health insurance designed for international students studying in Australia. It is a requirement for most student visa subclasses to ensure that students have access to necessary healthcare services during their studies in Australia.
      </p>

      <p>
        OSHC provides coverage for essential medical treatments, hospital stays, prescription medications, and emergency services. It helps international students manage the costs associated with healthcare while studying in Australia and ensures they have access to necessary medical care.
      </p>

      <p>
        <strong>Out-of-Pocket Expenses</strong>: Out-of-pocket expenses refer to the costs that individuals are responsible for paying directly when receiving healthcare services, even if they have health insurance coverage. These expenses can include deductibles, co-payments, and coinsurance, as well as any costs not covered by insurance. Out-of-pocket expenses can vary depending on the type of service, the insurance plan, and any applicable limits or exclusions.
      </p>

      <p>
        <strong>OVHC (Overseas Visitor Health Cover)</strong>: OVHC refers to health insurance specifically designed for visitors to Australia, including temporary residents, such as international students, working holiday visa holders, and temporary skilled workers. OVHC is a requirement for most visa subclasses to ensure that visitors have access to necessary healthcare services while in Australia.
      </p>

      <p>
        OVHC provides coverage for essential medical treatments, hospital stays, and emergency services during the visitor's stay in Australia. It helps protect visitors from the high costs of medical care and ensures they have access to necessary healthcare services during their time in the country.
      </p>

      <p>
        <a href="https://compareclub.com.au/health-insurance/pharmaceutical-benefits-scheme/" target="_blank" class="font-bold underline">PBS (Pharmaceutical Benefits Scheme)</a>: The Pharmaceutical Benefits Scheme is a program by the Australian Government that subsidizes the cost of a wide range of prescription medications, making them more affordable for Australian residents. Under the PBS, eligible individuals pay a reduced price (known as the patient co-payment) for prescribed medications, while the government covers the remaining cost. The PBS ensures access to essential medications at affordable prices for the Australian population.
      </p>

      <p>
        <a href="https://compareclub.com.au/health-insurance/pre-existing-conditions/" target="_blank" class="font-bold underline">Pre-existing Condition</a>: A medical condition that existed before an individual took out health insurance or upgraded their cover. Waiting periods may apply before coverage is provided for treatment related to pre-existing conditions.
      </p>

      <p>
        <a href="https://compareclub.com.au/health-insurance/preferred-providers/" target="_blank" class="font-bold underline">Preferred Provider</a>: Healthcare providers, such as doctors or specialists, who have an agreement with an insurance company to provide services at agreed-upon fees. Policyholders may receive higher benefits or reduced out-of-pocket expenses when using preferred providers.  
      </p>

      <p>
        <strong>Premium</strong>: The amount of money paid to the insurance company at regular intervals (monthly, quarterly, annually) to maintain health insurance coverage.
      </p>

      <p>
        <a href="https://compareclub.com.au/health-insurance/rebate/" target="_blank" class="underline font-bold">Private Health Insurance Rebate</a>: A government subsidy provided to eligible individuals to help offset the cost of private health insurance premiums. The rebate amount is based on income and age.  
      </p>

      <p>
        <a href="https://compareclub.com.au/health-insurance/waiting-periods/" target="_blank" class="underline font-bold">Waiting Period</a>: The specified period an individual must wait after taking out private health insurance or upgrading their cover before they can claim benefits for certain treatments or services. Waiting periods vary depending on the treatment or service.
      </p>
    `
  }
]

export const INFO_TABLE = [
  {
    title: 'Private Health Cover',
    list: [
      'Covers Medicare recognised elective surgery procedures and treatments',
      'Subsidised access to private hospital rooms',
      'Reduced wait times on elective surgeries',
      'Choose preferred doctor or surgeon',
      'Rebates for non-Medicare funded care<br/> (e.g. ambulance, dental, optical, physio)',
      'Exemption from MLS*',
      'Exemption from LHC if appropriate health cover taken out at 30 years old'
    ]
  },
  {
    title: 'Medicare Australia',
    list: [
      'Does not cover non-essential surgeries or treatments',
      'Access to a public hospital bed on a ward',
      'Often longer wait times for non–emergency surgeries in public hospitals',
      'Medical practitioner chosen for you',
      'Non-Medicare funded care paid for in full by patient',
      'Must pay the MLS if income is above threshold',
      'LHC must be paid at 2% for each year private health cover wasn’t in place since age 30**'
    ]
  }
]

export const TIERS_LIST = [
  {
    type: 'GOLD TIERS',
    title: 'Average Premiums: $193',
    desc: `
      <strong>Treatment Included:</strong><br />
      Covers 38 clinical categories of surgery & treatments
    `
  },
  {
    type: 'SILVER TIERS',
    title: 'Average Premiums: $150',
    desc: `
      <strong>Treatment Included:</strong><br />
      Covers 26 clinical categories of surgery & treatments
    `
  },
  {
    type: 'BRONZE TIERS',
    title: 'Average Premiums: $100',
    desc: `
      <strong>Treatment Included:</strong><br />
      Covers 18 clinical categories of surgery & treatments
    `
  },
  {
    type: 'BASIC TIERS',
    title: 'Average Premiums: $86',
    desc: `
      <strong>Treatment Included:</strong><br />
      Minimal cover for hospital
    `
  },
  {
    type: 'OVHC',
    title: 'Average Premiums: Varies',
    desc: `
      <strong>Treatment Included:</strong><br />
      Depending on your visa & situation, policies may include hospital, dental, GP & ambulance cover
    `
  }
]

export const COMPARISON_TABLE_DATA = {
  QLD: {
    'Couple 50+': '$439.23',
    Singles: '$219.61'
  },
  VIC: {
    'Couple 50+': '$458.80',
    Singles: '$229.40'
  },
  NSW: {
    'Couple 50+': '$424.66',
    Singles: '$212.33'
  },
  SA: {
    'Couple 50+': '$409.28',
    Singles: '$204.64'
  },
  WA: {
    'Couple 50+': '$373.64',
    Singles: '$186.82'
  },
  TAS: {
    'Couple 50+': '$413.03',
    Singles: '$206.51'
  },
  AUS: {
    'Couple 50+': '$419.77',
    Singles: '$208.89'
  }
}

export const WHY_GET_HEALTH_INSURANCE = {
  'First-Time Buyers': {
    'Waiting Periods': 'Private health insurance can offer shorter waiting periods for certain treatments compared to public healthcare.',
    'Medicare Levy Surcharge': 'Subject to your income private health insurance can help you avoid the Medicare Levy Surcharge, potentially saving you money at tax time.',
    'Lifetime Health Cover Loading': 'Getting private health insurance early in life can help you avoid Lifetime Health Cover Loading, saving you money in the long run.',
    'Hospital Wait Times': 'Private health insurance often means shorter hospital wait times for elective surgeries, enhancing your healthcare experience.',
    'Extras Cover': 'Extras cover allows first-time buyers to claim on services not covered by Medicare, like dental and physiotherapy.'
  },
  'Switching Plans': {
    'Waiting Periods': 'Switching plans may allow you to find a provider with shorter or waived waiting periods for certain services.',
    'Medicare Levy Surcharge': 'Switching plans can help you maintain your exemption from the Medicare Levy Surcharge, ensuring you continue to save.',
    'Lifetime Health Cover Loading': 'If you\'re switching plans, you can maintain your Lifetime Health Cover status and avoid additional loading.',
    'Hospital Wait Times': 'Switching plans can provide access to a wider network of hospitals, potentially reducing wait times further.',
    'Extras Cover': 'Switching plans can give you the opportunity to reassess and tailor your extras cover to better suit your current needs.'
  }
}

export const SITE_LINKS = [
  {
    title: 'Dental Extras',
    url: 'https://compareclub.com.au/health-insurance/dental/',
    desc: 'Dental extras cover helps pay for costs associated with dental care, from routine check-ups to complex procedures. With this, you can smile wider knowing your teeth are covered.'
  },
  {
    title: 'Optical Extras',
    url: 'https://compareclub.com.au/health-insurance/optical/',
    desc: 'Optical extras provide financial help for eye-related health care such as glasses and contact lenses. See life in a clearer light, and keep your eyes healthy with optical extras.'
  },
  {
    title: 'Medicare Levy Surcharge (MLS)',
    url: 'https://compareclub.com.au/health-insurance/medicare-levy-surcharge/',
    desc: 'The Medicare Levy Surcharge is a tax for Australians who don\'t have private health insurance but earn above a certain income. Avoid the surcharge, and benefit from private care by exploring health insurance options.'
  },
  {
    title: 'Overseas Visitors Cover',
    url: 'https://compareclub.com.au/health-insurance/visitors-visa-ovhc/',
    desc: 'This cover ensures visitors to Australia receive necessary medical treatment during their stay. If you\'re travelling to the land Down Under, consider getting overseas visitors cover for peace of mind.'
  },
  {
    title: 'Couples Health Insurance',
    url: 'https://compareclub.com.au/health-insurance/couples/',
    desc: 'A plan designed to cover both you and your partner\'s health needs. Simplify your policy management, potentially save costs, and ensure you both receive the care you need with couples health insurance.'
  },
  {
    title: 'Waiting Periods',
    url: 'https://compareclub.com.au/health-insurance/waiting-periods/',
    desc: 'These are set timeframes you must wait before claiming benefits after starting a new insurance policy or upgrading your current one. Understanding waiting periods helps avoid surprises when it comes time to use your insurance.'
  },
  {
    title: 'Switching Health Insurance',
    url: 'https://compareclub.com.au/health-insurance/switch/',
    desc: 'Changing your health insurer could help you find a better fit for your needs or reduce your premiums. If you\'re contemplating a switch, get informed to make sure the change works in your favour.'
  },
  {
    title: 'Ambulance Cover',
    url: 'https://compareclub.com.au/health-insurance/ambulance-cover/',
    desc: 'Ambulance cover takes care of costs related to emergency ambulance services. Without it, these costs can be hefty - secure this cover and ensure swift and affordable medical response when you need it most.'
  },
  {
    title: 'Family Cover',
    url: 'https://compareclub.com.au/health-insurance/families/',
    desc: 'Family health insurance plans provide coverage for all eligible family members under one policy. It\'s designed to protect those you love most, ensuring your family\'s health needs are covered without needing separate plans for each member.'
  }
]

export const HOME_TALK_TO_US = {
  averageSave: '$300*'
}